/**
 * 酒店注册页面 
 * @Author: centerm.gaohan 
 * @Date: 2020-10-12 11:39:58 
 * @Last Modified by: centerm.gaohan
 * @Last Modified time: 2020-11-26 10:57:30
 */
import React, { useEffect, useState } from 'react';
import { Toast, } from 'antd-mobile';
import invariant from 'invariant';
import { useHistory } from 'react-router-dom'
import { ComponentFormItem, FormItmeType } from '../../../../components/form';
import { api } from '../../../../common/app';
import FormLayout from './compoents/form-layout'
import "./index.css";
import { prefixPath } from './compoents/util';
import FormFooter from './compoents/form-footer';
import { useUserStatus } from '../../../../common/hooks/user-status';
import moment from 'moment';

export default (props: any) => {
  let params = props.match.params;
  const pathPrefix = prefixPath(props.match.url);
  const isEdit = window.location.href.indexOf('mine') > -1;
  const history = useHistory();
  const { modelstatus, meetindex } = useUserStatus(params.id);

  // 通用formitem属性 
  const [baseFormItemProps, setBaseFormItemProps] = useState({} as any);
  const [backBaseFormItemProps, setBackBaseFormItemProps] = useState({} as any);

  // 是否需要行程
  const [needJourneyPickerData] = useState([{ value: '1', label: '是' }, { value: '0', label: '否' }]);
  const [needJourneyGo, setNeedJourneyGo] = useState('');
  const [needJourneyBack, setNeedJourneyBack] = useState('');

  // 行程方式
  const [joryneyPickerData] = useState([{ value: '1', label: '火车' }, { value: '2', label: '飞机' }]);
  const [journeyGo, setJourneyGo] = useState('');
  const [journeyBack, setJourneyBack] = useState('');

  // 去程日期
  const [timeGo, setTimeGo] = useState('');
  // 返程日期
  const [timeBack, setTimeBack] = useState('');

  // 城市
  const [addressPickerData, setAddressPickerData] = useState([] as any[]);
  // 去程城市
  const [journeyAddressGo, setJoryneyAddressGo] = useState([]);
  // 返程城市
  const [journeyAddressBack, setJoryneyAddressBack] = useState([]);

  // 我的行程
  const [myJourney, setMyJourney] = useState({} as any);

  const [minDate, setMinDate] = useState(undefined as any);
  const [maxDate, setMaxDate] = useState(undefined as any);
  // 请求最迟和最早的入住时间
  useEffect(() => {
    console.log('meetindex', meetindex);
    if (meetindex.start_time && meetindex.end_time) {
      setMinDate(new Date(moment(meetindex.start_time * 1000).subtract(3, 'days').format('YYYY-MM-DD')));
      setMaxDate(new Date(moment(meetindex.end_time * 1000).add(3, 'days').format('YYYY-MM-DD')));
    }
  }, [meetindex]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, []);

  // 修改
  useEffect(() => {
    if (params.formid && addressPickerData.length > 0) {
      (api as any).myJourneyInfo({ meetid: params.id, id: params.formid })
        .then((response: any) => {
          if (response.code === 200) {
            const { go_data, back_data, identity } = response.result;

            setMyJourney(response.result);

            setNeedJourneyGo(`${go_data.is_need}`);
            setNeedJourneyBack(`${back_data.is_need}`);
            setJourneyGo(`${go_data.type}`);
            setJourneyBack(`${back_data.type}`);
            setTimeGo(new Date(go_data.depart_time * 1000) as any);
            setTimeBack(new Date(back_data.depart_time * 1000) as any);
            setJoryneyAddressGo([`${go_data.province_code}`, `${go_data.city_code}`] as any);
            setJoryneyAddressBack([`${back_data.province_code}`, `${back_data.city_code}`] as any);
          }
        })
        .catch((err: any) => {
          Toast.fail(err.message || '接口请求失败');
        });
    }
  }, [params, addressPickerData]);

  useEffect(() => {
    // 修改是否需要接机之后调整其他formitem是否可用
    let baseProps: any = {};
    if (needJourneyGo === '0') {
      baseProps.disabled = true;
    } else {
      baseProps.disabled = false;
    }

    if (modelstatus.journey?.status === false) {
      baseProps.disabled = true;
    }
    setBaseFormItemProps(baseProps);
  }, [needJourneyGo, modelstatus]);

  useEffect(() => {
    // 修改是否需要接机之后调整其他formitem是否可用
    let baseProps: any = {};
    if (needJourneyBack === '0') {
      baseProps.disabled = true;
    } else {
      baseProps.disabled = false;
    }

    if (modelstatus.journey?.status === false) {
      baseProps.disabled = true;
    }
    setBackBaseFormItemProps(baseProps);
  }, [needJourneyBack, modelstatus]);

  // 请求地址
  useEffect(() => {
    (api as any).getArea()
      .then((result: any) => {
        setAddressPickerData(result.result);
      })
      .catch((error: any) => {
        Toast.fail(error.message);
      })
  }, []);

  const onChangeValue = (value: any, callback: (params: any) => void) => {
    callback(value);
  }
  /**
   * 跳过设置酒店
   *
   */
  const onSkip = () => {
    (api as any).showButton({ meetid: params.id })
      .then((result: any) => {
        console.log('result', result);
        if (result.code !== 200) {
          return;
        }
        // 会议开启了酒店
        if (!!result.result.is_hotel && modelstatus.hotel.status === true) {
          history.replace(`/${pathPrefix}/hotel/${params.id}`);
          return;
        }
        // 会议开启了接送机
        if (!!result.result.is_plain && modelstatus.plain.status === true) {
          history.replace(`/${pathPrefix}/plain/${params.id}`);
          return;
        }
        history.replace(`/${pathPrefix}/index/${params.id}`);
      }).catch((err: any) => {
        console.log('err', err);
      });
  }

  /**
   * 用户点击填好之后触发验证然后调接口
   * 
   */
  const onSubmit = async () => {
    const isMine = window.location.href.indexOf("/mine/") > -1;
    try {
      invariant(!!needJourneyGo, '请选择是否需要去程');

      // 需要接机
      if (needJourneyGo === '1') {
        invariant(!!journeyGo, '请选择去程方式');
        invariant(!!timeGo, '请选择去程时间');
        invariant(!!journeyAddressGo, '请选择去程城市');
      }

      invariant(!!needJourneyBack, '请选择是否需要返程');
      // 需要送机
      if (needJourneyBack === '1') {
        invariant(!!journeyBack, '请选择返程方式');
        invariant(!!timeBack, '请选择返程时间');
        invariant(!!journeyAddressBack, '请选择返程城市');
      }

      const isEdit = !!params.formid;
      // 通用属性
      const payloadBase = {
        meetid: params.id,
      }

      const payloadPlain = {
        ...payloadBase,
        ...isEdit ? { id: myJourney.go_data.id } : {},
        // 1去2回
        train_type: 1,
        is_need: needJourneyGo,
        ...needJourneyGo === '1'
          ? {
            type: journeyGo,
            depart_time: !!timeGo && Math.ceil((timeGo as any).getTime() / 1000),
            city_code: journeyAddressGo ? journeyAddressGo[journeyAddressGo.length - 1] : '',
          }
          : {},
      }

      const payloadDelivery = {
        ...payloadBase,
        ...isEdit ? { id: myJourney.back_data.id } : {},
        // 1去2回
        train_type: 2,
        is_need: needJourneyBack,
        ...needJourneyBack === '1'
          ? {
            type: journeyBack,
            depart_time: !!timeBack && Math.ceil((timeBack as any).getTime() / 1000),
            city_code: journeyAddressBack ? journeyAddressBack[journeyAddressBack.length - 1] : '',
          }
          : {}
      }
      console.log('payloadPlain', payloadPlain);
      console.log('payloadDelivery', payloadDelivery);
      // 接送机的promises
      const promises = [
        (api as any).choiceJourney(payloadPlain),
        (api as any).choiceJourney(payloadDelivery),
      ];

      Promise.all(promises)
        .then((result) => {
          const resultPlain = result[0];
          const resultDelivery = result[1];
          if (resultPlain.code !== 200) {
            Toast.fail(resultPlain.message);
            return;
          }
          if (resultDelivery.code !== 200) {
            Toast.fail(resultDelivery.message);
            return;
          }
          Toast.success('更新成功！', 1);
          // 成功之后跳转

          setTimeout(() => {
            // 修改返回
            if (!!isMine) {
              history.goBack();
              return;
            }

            (api as any).showButton({ meetid: params.id })
              .then((result: any) => {
                console.log('result', result);
                if (result.code !== 200) {
                  return;
                }
                // 会议开启了酒店
                if (!!result.result.is_hotel && modelstatus.hotel.status === true) {
                  history.replace(`/${pathPrefix}/hotel/${params.id}`);
                  return;
                }
                // 会议开启了接送机
                if (!!result.result.is_plain && modelstatus.plain.status === true) {
                  history.replace(`/${pathPrefix}/plain/${params.id}`);
                  return;
                }
                history.replace(`/${pathPrefix}/index/${params.id}`);
              }).catch((err: any) => {
                console.log('err', err);
              });
          }, 1000);

        }).catch((error) => {
          Toast.fail(error.message, 1);
        });
    } catch (error) {
      Toast.fail(error.message, 1);
    }
  }

  return (
    <FormLayout>
      <div className='form-register-title'>填写去程信息</div>
      <ComponentFormItem
        cols={1}
        extra='请选择是否需要去程'
        formType={FormItmeType.Picker}
        data={needJourneyPickerData}
        value={[needJourneyGo]}
        onOk={(params) => onChangeValue(params[0], setNeedJourneyGo)}
        disabled={modelstatus.journey?.status === false}
      />
      <ComponentFormItem
        cols={1}
        extra='请选择提供的行程方式'
        formType={FormItmeType.Picker}
        data={joryneyPickerData}
        value={[journeyGo]}
        onOk={(params) => onChangeValue(params[0], setJourneyGo)}
        {...baseFormItemProps}
      />

      <ComponentFormItem
        mode='date'
        extra='请选择去程日期'
        formType={FormItmeType.DatePicker}
        value={timeGo}
        onOk={(params: any) => onChangeValue(params, setTimeGo)}
        {...minDate !== undefined ? { minDate: minDate } : {}}
        {...maxDate !== undefined ? { maxDate: maxDate } : {}}
        {...baseFormItemProps}
      />

      <ComponentFormItem
        formType={FormItmeType.Picker}
        extra='请选择出发城市'
        cols={2}
        data={addressPickerData}
        value={journeyAddressGo}
        onOk={(params) => onChangeValue(params, setJoryneyAddressGo)}
        {...baseFormItemProps}
      />
      <div className='form-register-title'>填写返程信息</div>
      <ComponentFormItem
        disabled={modelstatus.journey?.status === false}
        cols={1}
        extra='请选择是否需要返程'
        formType={FormItmeType.Picker}
        data={needJourneyPickerData}
        value={[needJourneyBack]}
        onOk={(params) => onChangeValue(params[0], setNeedJourneyBack)}
      />

      <ComponentFormItem
        cols={1}
        extra='请选择提供的行程方式'
        formType={FormItmeType.Picker}
        data={joryneyPickerData}
        value={[journeyBack]}
        onOk={(params) => onChangeValue(params[0], setJourneyBack)}
        {...backBaseFormItemProps}
      />

      <ComponentFormItem
        mode='date'
        extra='请选择回程日期'
        formType={FormItmeType.DatePicker}
        value={timeBack}
        onOk={(params: any) => onChangeValue(params, setTimeBack)}
        {...minDate !== undefined ? { minDate: minDate } : {}}
        {...maxDate !== undefined ? { maxDate: maxDate } : {}}
        {...backBaseFormItemProps}
      />

      <ComponentFormItem
        formType={FormItmeType.Picker}
        extra='请选择回去城市'
        cols={2}
        data={addressPickerData}
        value={journeyAddressBack}
        onOk={(params) => onChangeValue(params, setJoryneyAddressBack)}
        {...backBaseFormItemProps}
      />
      <FormFooter
        meetid={params.id}
        type='journey'
        isEdit={isEdit}
        onSkip={onSkip}
        onSubmit={onSubmit}
      />
    </FormLayout>
  );
}